// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your Firebase configuration (from Firebase Console)
const firebaseConfig = {
    apiKey: "AIzaSyAwMNLrltLZWP4d4_ryzreypUXVzIPFjzo",
    authDomain: "umraah-taxi-services.firebaseapp.com",
    projectId: "umraah-taxi-services",
    storageBucket: "umraah-taxi-services.firebasestorage.app",
    messagingSenderId: "175252015367",
    appId: "1:175252015367:web:15082b1b614ae107905da2",
    measurementId: "G-LG36J6QJTZ"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db };
